module.exports = __webpack_public_path__ + "static/media/TUNE_4353.1b2c646f.jpg";